export enum EProductTemplateUsageEventStep {
  PLACE_ORDER = 'place_order',
  ADD_TO_STORE = 'add_to_store',
  ADD_PRODUCT_BUTTON = 'add_product_button',
}
